import { render, staticRenderFns } from "./bsp-pagination.vue?vue&type=template&id=b3cb880c&scoped=true&"
import script from "./bsp-pagination.vue?vue&type=script&lang=js&"
export * from "./bsp-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cb880c",
  null
  
)

export default component.exports